import React from "react";
import { dateFormatter } from '../helpers'
import store from './Stores/SurveyStore'
import ibsStore from './Stores/IbsSurveyStore'
import { getSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";

const SurveyLabelField = (props) => {
    let serviceStore = store;
    if (window.location.href.includes('db') || window.location.href.includes('dc')) 
        serviceStore = ibsStore;

    let value;
    if (window.location.href.includes('pabs') && serviceStore.showAdminPanel) {
        if (props.rowData) value = props.rowData[props.name]
        if ((props.name === "dateLastActive" || props.name === "dateFirstDone") && value) {
            value = dateFormatter(value.substring(0, 10))
        }
       
    } else if (props.rowData) {
        value = getSurveyResponseValue(props.name, props.rowData)
        if (value == null || value === "") {
            value = props.name

            //Redo if possible
            if (value === "NumChanges") {
                value = 0;
            }
        }
    }

    return (
        <span className = "" dangerouslySetInnerHTML={{ __html: value }}>
        </span>
    );
};

export default SurveyLabelField;
